export enum OrderItemType {
  item = 'item',
  gift_card = 'gift_card',
}
